import CartTools from './CartTools.js'

export default {
    prepareProductList(source, list) {
        let listProducts = []
        if (source === 'sales') {
            list.forEach(element => {
                let subtotal = CartTools.calculatePriceFromProductItem(element)
                let product = {
                    id: element.id,
                    name: element.name,
                    description: element.description,
                    quantity: element.quantity,
                    base_price: element.base_price,
                    discount_amount: element.discount_amount,
                    discount_value: element.discount_value,
                    subtotal: subtotal,
                    has_return: element.has_return,
                    is_bonus: element.is_bonus
                }

                listProducts.push(product)
            })
        } else if (source === 'orders') {
            list.forEach(element => {
                let product = {
                    id: element.id,
                    name: element.name,
                    description: element.description,
                    quantity: element.quantity,
                    base_price: element.base_price,
                    discount_amount: element.discount_amount,
                    discount_value: element.discount_value,
                    subtotal: element.subtotal,
                    has_return: element.has_return,
                    is_bonus: element.is_bonus
                }
                listProducts.push(product)
            });
        }
        return listProducts
    }
}